import { superModal, successModal, errorModal, confirmModal, formModal, infoModal, contentModal, courseConfirmModal } from './modal';

export function ajaxCall(url, method, data) {
    $ = jQuery;
    $.ajax({
        url: url,
        contentType: false,
        processData: false,
        data: data,
        type: method,

        beforeSend: function() {
            let fields = $('.validation-error');
            fields.removeClass('validation-error');
            fields.siblings('small').remove();
            $('.status').html("");
        },

        complete: function(){
            $('.load').removeClass('load');
        },

        error: function(xhr, textStatus) {
            try{
                let data = JSON.parse(xhr.responseText);
                //Validátor
                if(xhr.status == 400){
                    if(data.action == "error-modal")
                        setTimeout(function() {errorModal(data.message);}, 500)
                    else{
                        let highest = Number.MAX_SAFE_INTEGER;
                        for(let key of Object.keys(data)){
                            let field = $(`*[name='${key}']`);
                            if(field.offset().top < highest && field.parents('.modal').length == 0)
                                highest = field.offset().top;
                            field.addClass('validation-error');
                            field.parent().append(`<small>${data[key]}</small>`);
                        }
                        if(highest != Number.MAX_SAFE_INTEGER)
                            $("html, body").animate({ scrollTop: highest - 150 }, 600);
                    }
                }               
                //Validátor mező nem szerepel
                if(xhr.status == 406)
                    errorModal(data.message);
                if(xhr.status == 403)
                    $('.status').html(data.message);
                if(xhr.status == 500)
                    setTimeout(function() {errorModal(data.message);}, 500)
            }catch(e){
                console.error(e);
                setTimeout(function() {errorModal(data.message);}, 500)
            }
        },

        success: function(response, textStatus, xhr) {
            console.log("success");
            try{
                let data = JSON.parse(response);
                $('.modal').modal('hide');
                if(xhr.status == 200 || xhr.status == 201)
                    if(redirects !== undefined && redirects == true)
                        redirectFromLocalStorage();
                    else if(data.action == 'redirect')
                        window.location = data.url;
                    else if(data.action == 'reload')
                        window.location.reload();
                    else if(data.action == 'vote')
                        initProgress();
                    else if(data.action == 'form-modal'){
                        $('#super-modal .modal-body').html(data.html);
                        initImageUpload();
                        initDateFormatter();

                        if($('#super-modal select').length)
                            $('#super-modal select').selectmenu();
                        if(data.spec == 'course-append')
                            courseAppendInfo();
                    }
                    else if(data.action == 'success-modal')
                        successModal(data.message, data.url, data.title);
                    else if(data.action == 'newsletter-modal'){
                        $('#newsletter-modal').modal('hide');
                        successModal(data.message, data.url);
                    }
            }catch(e){
                console.error(e);
                errorModal("Váratlan hiba lépett fel!");
            }
        }
    });
}